import { Component, Input } from '@angular/core';
import { BaseEntity } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { EnumPageDisplayModes, EnumPageEntitySources, EnumInputBoxTypes } from '@core/framework/sysenums.enum';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';

class State
{
    Value: any; 
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-inputboxdialog',
    templateUrl: './inputboxdialog.component.html',
    styleUrls: ['./inputboxdialog.component.scss']
})
export class InputBoxDialogComponent extends BasePageComponent<BaseEntity, State>
{
    @Input() FieldLabel = '';
    @Input() Title: string = this.GetDefaultTitle();
    @Input() Prompt: string;
    @Input() Type: EnumInputBoxTypes = EnumInputBoxTypes.Text;

    @Input() set Value(value: any) {
        setTimeout(() => { this.State.Value = value });
    }

    constructor(A: ServiceBagService)
    {
        super(A, 'InputBoxDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    protected override OnInitTitle()
    {
        return this.Title;
    }

    override GetDefaultTitle() {
        const moduleName = this.GetFirstModuleName();
        return this.A.ResourcesService.RC('AppTitles.Messages', moduleName);
    }    
}
